<template>
  <div>
        <el-dialog
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      width="55%"
      title="投诉建议"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="complaintForm"
        ref="complaintFormRef"
        :rules="complaintFormRules"
        class="from-box"
        label-width="100px"
      >
        <el-form-item label="投诉类型" prop="type">
          <el-radio-group v-model="complaintForm.type">
            <el-radio :label="1">平台体验</el-radio>
            <el-radio :label="2">客服体验</el-radio>
            <el-radio :label="3">关于询单</el-radio>
            <el-radio :label="4">关于订单</el-radio>
            <el-radio :label="6">关于商品</el-radio>
            <el-radio :label="5">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="反馈描述" prop="content">
          <el-input
            v-model="complaintForm.content"
            type="textarea"
            placeholder="请输入内容"
            rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传图片" prop="images">
          <span class="desc">最多上传5张图片</span>
          <ImageUpload
            :maxCount="5"
            v-model="complaintForm.images"
            @change="handleComplaintImage"
            :value="complaintForm.images"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { feedback } from "@/api/modules/user.js";
import ImageUpload from "@/components/public/ImageUpload.vue";
export default {
  name: 'add_complaint',
  components:{
    ImageUpload
  },
  props:{
    dialogFormVisible:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      complaintForm: {
        images: [],
        content: "",
        type: "",
      },
      complaintFormRules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        content: [
          { required: true, message: "请输入反馈描述", trigger: "blur" },
        ]
      },
    }
  },
  methods:{
    close(){
      this.$emit('close')
    },
    handleComplaintImage(data) {
      this.complaintForm.images = data;
    },
    handleSubmit(){
      this.$refs.complaintFormRef.validate((valid) => {
        if (valid) {
          feedback(this.complaintForm).then((res) => {
            if (res.data.code == 10000) {
              this.$message.success({
                message: res.data.message,
                type: "success",
                duration: 1000,
                offset: 100,
              });
            } else {
              this.$message.error({
                message: res.data.message,
                type: "error",
                duration: 1000,
                offset: 100,
              });
            }
            this.$refs.complaintFormRef.resetFields();
            this.$emit('success')
          });
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
</style>
